module.exports = __webpack_public_path__ + "static/media/sample1.17261659.png";